
import React from "react";
import ProductInfo from "./ProductInfo";
import { MdOutlineFileDownload } from "react-icons/md";
import { useTranslation } from 'react-i18next';

/* ---------------------------------------------------------------------------- */

import {
  DownloadButton,
  DownloadList,
  ProductDescription,
  ProductDocument,
  ProductImage,
  ProductSection,
} from "./StyledComponents";

/* ----------------------------------------------------------------------------
 *          IMAGES
 * --------------------------------------------------------------------------- */

import TryggVardagKlockaBild from "../../../../data/images/products/Trygg Vardag Klocka/Huvudbild_klocka.png";


/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES
 * --------------------------------------------------------------------------- */

import TryggVardagKlockaManual from "../../../../data/downloads/Manual-trygg-vardag-klocka.pdf";
import TryggVardagKlockaStartaUpp from "../../../../data/downloads/Starta-upp-trygg-vardag-klocka.pdf";
import TryggVardagRekond from "../../../../data/downloads/Trygg_vardag_rekonditionering_nya.pdf";


/* ============================================================================ */
/*          PORT | KOMM - function
/* ============================================================================ */


const TryggVardagKlocka = () => {
  
  const { t } = useTranslation("products/tryggvardagklocka"); 

  return (
    <main className="product container">
      <ProductSection>
        <h1>{t('h1_tryggvardagklocka')}</h1>
        <ProductImage src={TryggVardagKlockaBild} alt="" />

        <ProductDescription>
          <p>{t('p1_tryggvardagklocka')}</p>
          <p>{t('p2_tryggvardagklocka')}</p>
          <p>{t('p3_tryggvardagklocka')}</p>
        </ProductDescription>
    
        <ProductInfo titel={t('dokument_tryggvardagklocka')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardagklocka')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagKlockaManual} download="manual-trygg-vardag-klocka.pdf">
                    <span>Användarmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>                
                <DownloadButton>
                  <a href={TryggVardagKlockaStartaUpp} download="Starta-upp-trygg-vardag-klocka.pdf">
                    <span>Starta upp Manual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagRekond} download="manual-trygg-rekonditionering.pdf">
                    <span>Rekonditionersingsmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>
        
      </ProductSection>
    </main>
  );
};

export default TryggVardagKlocka;
